import React from 'react';
import { withRouter } from 'react-router-dom';

class ScrollTop extends React.Component {
	componentDidMount(prevProps) {
		if (!prevProps) return;

		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0);
		}
	}

	render() {
		return this.props.children;
	}
}

export default withRouter(ScrollTop);



// WEBPACK FOOTER //
// ./src/components/ScrollTop.js